import { ComponentProps } from 'react'
import { SelectionSet, SelectionSetInput, SelectionSetLabel } from '@vp/swan'

import { FilterOption } from '~/app/features/Gallery/components/Filters/FilterOption'
import { buildRefinement, refinementAddAndRemove } from '~/app/store/refinement'
import { REFINEMENT_DIMENSION } from 'shared/constants'
import { useDispatch } from 'react-redux'
import { scrollUpToElement } from '~/app/utils/scrollToElement'
import { galleryHeaderId } from '~/app/features/Gallery/components/Header/ActionHeader/constants'
import { isFilterModalHidden } from '~/app/features/Gallery/components/Header/ActionHeader/components/FilterMenu/utils'
import { useRedirectToL0 } from '~/app/features/Gallery/hooks/RedirectToL0/useRedirectToL0'
import { ThunkDispatch } from '~/app/store/interface'

export interface PropTypes {
  options: RenderableFilterOption[]
  title: string
  refinementDimension: REFINEMENT_DIMENSION
  SelectionSetProps?: Omit<
    ComponentProps<typeof SelectionSet>,
    'defaultSelectedValue' | 'variant' | 'selectedValue' | 'selectedValues' | 'onSelectedValueChange' | 'onSelectedValuesChange' | 'skin'
  >
  selectedValues: SelectedValues
  shouldShowFilterOption?: (o: RenderableFilterOption) => boolean
}

export const FilterCheckboxList = (props: PropTypes) => {
  const { options, title, refinementDimension, SelectionSetProps, selectedValues, shouldShowFilterOption = (): boolean => true } = props

  const dispatch = useDispatch<ThunkDispatch>()
  const redirectToL0 = useRedirectToL0()

  const handleSelectedValuesChange = (newSelectedValues: SelectedValues): void => {
    const toAdd: State.Refinement[] = []
    const toRemove: State.Refinement[] = []

    for (const [value, isSelected] of Object.entries(newSelectedValues)) {
      const refinement = buildRefinement(value, refinementDimension)

      ;(isSelected ? toAdd : toRemove).push(refinement)
    }

    if (redirectToL0(toAdd, toRemove)) {
      return
    }

    dispatch(refinementAddAndRemove(toAdd, toRemove))
    if (isFilterModalHidden()) {
      scrollUpToElement(galleryHeaderId)
    }
  }

  return (
    <SelectionSet
      aria-label={title}
      className="selection-set-layout-override"
      id={`selection-set-${title}`}
      selectedValues={selectedValues}
      skin="simple-column"
      variant="multi-select"
      onSelectedValuesChange={handleSelectedValuesChange}
      {...SelectionSetProps}
    >
      {options.filter(shouldShowFilterOption).map((o) => (
        <div className="selection-set-item" data-testid="filter-value" key={o.value}>
          <SelectionSetInput disabled={o.disabled} value={o.value}>
            <SelectionSetLabel>
              <FilterOption facetCount={o.facetCount} title={o.title} />
            </SelectionSetLabel>
          </SelectionSetInput>
        </div>
      ))}
    </SelectionSet>
  )
}

FilterCheckboxList.displayName = 'FilterCheckboxList'
